import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Toolbar.module.scss';
import Wall from '../Wall';

function Toolbar(props) {
  const { children, name, grow } = props;

  const classes = [styles.nav_important, styles.toolbar];

  if (grow) {
    classes.push(styles.grow);
  }

  if (props.margin_bottom) {
    classes.push(styles.margin_bottom);
  }

  if (props.color === 'transparent') {
    classes.push(styles.transparent);
  }

  return (
    <div className={cn(classes)}>
      {name && (
        <div className={cn(styles.nameWrapper)}>
          <span>{name}</span>
          <Wall />
        </div>
      )}
      <div className={styles.additionalContent}>{children}</div>
    </div>
  );
}

export default Toolbar;

Toolbar.defaultProps = {
  children: null,
  name: undefined,
  grow: false,
  color: '',
  margin_bottom: false,
  additional_span: '',
  url: '',
};

Toolbar.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  grow: PropTypes.bool,
  color: PropTypes.string,
  margin_bottom: PropTypes.bool,
  additional_span: PropTypes.string,
  url: PropTypes.string,
};
